// extracted by mini-css-extract-plugin
module.exports = {"textbox":"Textbox_textbox__1QEK0","invalid":"Textbox_invalid__1Sngw","broadcastMessage":"Textbox_broadcastMessage__3SpG7","fieldValidation":"Textbox_fieldValidation__2BYLT"};